import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatSelectModule} from '@angular/material/select';
import {PortalSelectModule} from '../portal-select/portal-select.module';
import {LocalPaginatorComponent} from './local-paginator.component';

@NgModule({
  declarations: [LocalPaginatorComponent],
  imports: [
    CommonModule,
    MatSelectModule,
    PortalSelectModule
  ],
  exports: [
    LocalPaginatorComponent
  ]
})
export class LocalPaginatorModule {
}
